"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthPlannedMinutesCell = void 0;
const util_1 = require("@app/util");
const format_hours_1 = require("@app/util/format-hours");
const react_1 = __importDefault(require("react"));
const sort_by_1 = require("../../sort-by");
const Cell = ({ monthContractMinutes, monthPlannedMinutes, monthOverTimeMinutes, }) => {
    const workedMoreThanPlanned = monthPlannedMinutes > monthContractMinutes;
    const workedLessThanPlanned = monthPlannedMinutes < monthContractMinutes;
    const workedAsPlanned = monthPlannedMinutes === monthContractMinutes;
    return (react_1.default.createElement("td", null,
        workedMoreThanPlanned && react_1.default.createElement("span", { className: 'arrow-up' }, "\u25B2"),
        workedLessThanPlanned && react_1.default.createElement("span", { className: 'arrow-down' }, "\u25BC"),
        workedAsPlanned && react_1.default.createElement("span", { className: 'no-arrow' }),
        (0, format_hours_1.formatHours)(util_1.timeUtil.asHour(monthPlannedMinutes)),
        ' ',
        monthOverTimeMinutes
            ? `(+${(0, format_hours_1.formatHours)(util_1.timeUtil.asHour(monthOverTimeMinutes))})`
            : null));
};
const MonthPlannedMinutesCell = ({ sortData, monthContractMinutes, monthPlannedMinutes, monthOverTimeMinutes, monthOverTimeMinutesByContract, monthOverTimeMinutesByPosition, monthContractMinutesByContract, monthPlannedMinutesByContract, monthPlannedMinutesByPosition, }) => {
    if (!(0, util_1.isUndefined)(sortData)) {
        // render if sorted by CONTRACT
        if (sortData.sortedBy === sort_by_1.SORT_BY.CONTRACT) {
            const _monthContractMinutes = monthContractMinutesByContract.find((contract) => contract.contractType === sortData.id)?.minutes ?? 0;
            const _monthPlannedMinutes = monthPlannedMinutesByContract.find((contract) => contract.contractType === sortData.id)?.minutes ?? 0;
            const _monthOverTimeMinutes = monthOverTimeMinutesByContract?.find((contract) => contract?.contractType === sortData.id)?.minutes ?? 0;
            return (react_1.default.createElement(Cell, { monthContractMinutes: _monthContractMinutes, monthPlannedMinutes: _monthPlannedMinutes - _monthOverTimeMinutes, monthOverTimeMinutes: _monthOverTimeMinutes }));
        }
        // render if sorted by POSITION
        if (sortData.sortedBy === sort_by_1.SORT_BY.POSITION) {
            const _monthPlannedMinutes = monthPlannedMinutesByPosition.find((position) => position.positionId === sortData.id)?.minutes ?? 0;
            const _monthOverTimeMinutes = monthOverTimeMinutesByPosition?.find((position) => position?.positionId === sortData.id)?.minutes ?? 0;
            return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes, monthPlannedMinutes: _monthPlannedMinutes - _monthOverTimeMinutes, monthOverTimeMinutes: _monthOverTimeMinutes }));
        }
    }
    // render default
    return (react_1.default.createElement(Cell, { monthContractMinutes: monthContractMinutes, monthPlannedMinutes: monthPlannedMinutes, monthOverTimeMinutes: monthOverTimeMinutes }));
};
exports.MonthPlannedMinutesCell = MonthPlannedMinutesCell;
